import { render, staticRenderFns } from "./TroncoComun.vue?vue&type=template&id=81cc8684&"
import script from "./TroncoComun.vue?vue&type=script&lang=js&"
export * from "./TroncoComun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports